import { useState, useEffect } from "react";
import "../src/assets/components/global.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import AutoLogout from "./autologout";
import axios from "axios";
import Swal from "sweetalert2";

function Viewrequest() {
  const [adminData, setAdminData] = useState({ users: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const navigate = useNavigate();
  const [firstname, setFirstname] = useState("");

  useEffect(() => {
    axios
      .get(
        `https://brgytracerappserver.onrender.com/viewrequest?firstname=${firstname}`
      )
      .then((res) => {
        console.log(res.data);
        setAdminData(res.data);
      })
      .catch((err) => console.log(err));
  }, [firstname]);

  const handleSearchInputChange = (e) => {
    setFirstname(e.target.value);
  };

  const handleDecline = (getbID) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, decline it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .put(
            `https://brgytracerappserver.onrender.com/declinerequest/${getbID}`
          )
          .then((res) => {
            Swal.fire({
              title: "Declined!",
              text: "User request Declined!.",
              icon: "success",
            });
            axios
              .get("https://brgytracerappserver.onrender.com/viewrequest")
              .then((res) => {
                setAdminData(res.data);
              });
            Swal.fire({
              icon: "error",
              title: "Something went wrong!",
              text: "System error!!",
            });
          });
        Swal.fire({
          icon: "error",
          title: "Something went wrong!",
          text: "System error!!",
        });
      }
    });
  };

  const handleRead = (getID) => {
    navigate(`/readrequest/${getID}`);
  };

  const handleClose = () => {
    navigate("/adminpage");
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      Math.min(prevPage + 1, Math.ceil(adminData.users.length / rowsPerPage))
    );
  };

  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentUsers = adminData.users.slice(startIndex, endIndex);

  return (
    <div className="viewrequest-parent parent-height">
      <AutoLogout />
      <div className="container">
        <div className="searchbox">
          <div>
            <FontAwesomeIcon icon={faSearch} />
            <input
              type="text"
              placeholder="Search by FirstName"
              value={firstname}
              onChange={handleSearchInputChange}
            />
          </div>
        </div>
        <div className="datagrid-parent">
          <button className="closebtn" type="button" onClick={handleClose}>
            X
          </button>
          <h1>List of Requesting Update</h1>
          {currentUsers.length > 0 ? (
            <div className="datagrid-holder">
              <table>
                <thead>
                  <tr>
                    <th>BrgyId</th>
                    <th>First Name</th>
                    <th>Family Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentUsers.map((user) => (
                    <tr key={user.brgyId}>
                      <td>{user.brgyId}</td>
                      <td>{user.firstname}</td>
                      <td>{user.lastname}</td>
                      <td>{user.email}</td>
                      <td>{user.role}</td>
                      <td
                        className="handleEdit"
                        onClick={() => handleRead(user.brgyId)}>
                        Read
                      </td>
                      <td
                        className="handleDelete"
                        onClick={() => handleDecline(user.brgyId)}>
                        Decline
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="pagination-controls">
                <button
                  className="pagination-button"
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}>
                  Previous
                </button>
                <span className="pagination-info">
                  Page {currentPage} of{" "}
                  {Math.ceil(adminData.users.length / rowsPerPage)}
                </span>
                <button
                  className="pagination-button"
                  onClick={handleNextPage}
                  disabled={
                    currentPage ===
                    Math.ceil(adminData.users.length / rowsPerPage)
                  }>
                  Next
                </button>
              </div>
            </div>
          ) : (
            <p className="noUsertext">No users available for display.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Viewrequest;
